/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ExportColumnGroup {
  ROUTE="ROUTE",
ORDER="ORDER",
SCHEDULING="SCHEDULING",
PROOF_OF_DELIVERY="PROOF_OF_DELIVERY",
CUSTOM_FIELD="CUSTOM_FIELD"
}

/**
* ExportColumnGroup
*/
export const ExportColumnGroupEnumType = types.enumeration("ExportColumnGroup", [
        "ROUTE",
  "ORDER",
  "SCHEDULING",
  "PROOF_OF_DELIVERY",
  "CUSTOM_FIELD",
      ])
